// import {
//   Box,
//   Grid,
//   TextField,
//   createTheme,
//   ThemeProvider,
//   Stack,
//   Collapse,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import Button from "@mui/material/Button";
// import Dialog from "@mui/material/Dialog";
// import ListItemText from "@mui/material/ListItemText";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import KeyIcon from "@mui/icons-material/Key";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
// import Typography from "@mui/material/Typography";
// import CloseIcon from "@mui/icons-material/Close";
// import Slide from "@mui/material/Slide";
// import AutorenewIcon from "@mui/icons-material/Autorenew";


// import MUIDataTable from "mui-datatables";

// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import StatusAlert from "../../../StatusAlertList/StatusAlert";
// import PermissionTable from "./PermissionTable";

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="down" ref={ref} {...props} />;
// });

// function RolesSettings() {
//   const [open, setOpen] = React.useState(false);

//   const [tax_name, setTax_name] = React.useState("");

//   const [leadSource, setLeadSource] = useState([]);

//   const [permission, setPermission] = useState(false);
//   const [expandedRows, setExpandedRows] = useState([]);
//   const [update, setUpdate] = React.useState(false);

//   const [alertOpen, setAlertOpen] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");
//   const showAlert = (message, severity) => {
//     setAlertMessage(message);
//     setAlertSeverity(severity);
//     setAlertOpen(true);
//   };

//   const handleClickUpdate = () => {
//     setUpdate(true);
//   };

//   const handleUpdateClose = () => {
//     setUpdate(false);
//   };

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   useEffect(() => {
//     getData();
//   }, []);
//   const toggleRow = (rowId) => {
//     setExpandedRows((prevExpandedRows) => {
//       // Toggle the expansion state of the row
//       if (prevExpandedRows.includes(rowId)) {
//         return prevExpandedRows.filter((id) => id !== rowId);
//       } else {
//         return [...prevExpandedRows, rowId];
//       }
//     });
//   };
// async function getData() {
//   try {
//     let results = await fetch(
//       "https://rptpl.roadpilot.co.in/public/api/getRoles"
//     );
//     let data = await results.json();
    
//     // Transform the data to have the exact structure expected by MUIDataTable
//     const transformedData = Array.isArray(data) ? data.map(item => ({
//       role: item.role || "",
//       id: item.id || "",
//       status: item.status !== undefined ? item.status : 0
//     })) : [];
    
//     setLeadSource(transformedData);
//   } catch (error) {
//     console.error("Error fetching roles:", error);
//     setLeadSource([]);
//   }
// }

//   const columns = [
//     {
//       name: "role",
//       label: "",
//       options: {
//         customBodyRender: (value, tableMeta) => {
//           const rowId = tableMeta.rowIndex;

//           return (
//             <div>
//               <span>
//                 {(value || " ").charAt(0).toUpperCase() +
//                   (value || " ").slice(1)}
//               </span>
//               <div style={{ fontSize: "12px", color: "#777" }}>
//                 {rowId === 0 ? "Admin Member" : "0 Member"}
//               </div>
//             </div>
//           );
//         },
//       },
//     },

//     {
//       name: "id",
//       label: "",
//       options: {
//         customHeadRender: () => null,
//         customBodyRender: (value, tableMeta) => {
//           const rowId = tableMeta.rowIndex; // Get the row index from tableMeta
//           const isExpanded = expandedRows.includes(rowId); // Check if this row is expanded
//           const rowStatus = leadSource[rowId]?.status;
//           return rowId === 0 ? (
//             <div style={{ textAlign: "right" }}>
//               Admin permissions can not be changed
//             </div>
//           ) : (
//             <>
//               <Stack
//                 spacing={2}
//                 direction="row"
//                 sx={{
//                   justifyContent: "flex-end",
//                   "& .MuiButton-root": {
//                     margin: "0 4px",
//                   },
//                 }}
//               >
//                 <Button
//                   variant="outlined"
//                   onClick={() => handleStatus(value)}
//                   sx={{
//                     color: rowStatus === 0 ? "#f15f5f" : "#68f15f", // Check status value
//                     border: `1px solid ${
//                       rowStatus === 0 ? "#f15f5f" : "#68f15f"
//                     }`,
//                     "&:hover": {
//                       borderColor: rowStatus === 0 ? "#ff7b7b" : "#89ff89", // Hover border color
//                       backgroundColor: "transparent", // Maintain transparency on hover
//                     },
//                     transition: "border-color 0.3s ease", // Smooth transition
//                   }}
//                 >
//                   <AutorenewIcon /> Status
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   onClick={() => handleDelete(value)}
//                   sx={{
//                     color: "#f15f5f",
//                     border: "1px solid #f15f5f",
//                     "&:hover": {
//                       borderColor: "#f15f5f",
//                       backgroundColor: "transparent",
//                     },
//                     transition: "border-color 0.3s ease",
//                   }}
//                 >
//                   <DeleteForeverIcon /> Delete
//                 </Button>
//                 <Button variant="outlined" onClick={() => toggleRow(rowId)}>
//                   <KeyIcon /> Permission
//                 </Button>
//               </Stack>

//               <Collapse in={isExpanded} timeout="auto" unmountOnExit>
//                 <Box sx={{ margin: 1, padding: 1, backgroundColor: "#f0f0f0" }}>
//                   <PermissionTable />
//                 </Box>
//               </Collapse>
//             </>
//           );
//         },
//       },
//     },
//   ];
//   async function handleStatus(id) {
//     const response = await fetch(
//       "https://rptpl.roadpilot.co.in/public/api/changestatus/" + id,
//       {
//         method: "POST",
//       }
//     );
//     console.log(response, "responsestatus");
//     if (response.ok) {
//       setLeadSource((prevData) =>
//         prevData.map((row) =>
//           row.id === id ? { ...row, status: !row.status } : row
//         )
//       );
//     }
//     getData();
//     handleClickUpdate();
//   }
//   const handlePermission = () => {
//     setPermission(!permission);
//   };

//   async function handleDelete(id) {
//     const response = await fetch(
//       "https://rptpl.roadpilot.co.in/public/api/deleteRoles/" + id,
//       {
//         method: "DELETE",
//       }
//     );
//     console.log(response, "response");
//     //const result = await response.json(); // Assigning to a new variable
//     if (response.ok) {
//       getData();
//       console.log("deleted called");
//       showAlert(" Deleted Successfully!", "warning");
//     } else {
//       showAlert(" Deleted failed!", "error");
//     }
//   }

//   // Save Lead Sourse
//   const username = localStorage.getItem("name");
//   async function SaveDate() {
//     try {
//       const response = await fetch(
//         `https://rptpl.roadpilot.co.in/public/api/addRole?role=${tax_name}&creator_id=${username}`,
//         {
//           method: "POST",
//         }
//       );
//       console.log(response);
//       // Check if the response is okay
//       if (!response.ok) {
//         throw new Error(`Network response was not ok: ${response.statusText}`);
//       }

//       // Read response as text for debugging

//       // Try parsing the response as JSON

//       showAlert(" Added Successfully!", "success");
//       getData();
//       setOpen(false);
//     } catch (error) {
//       console.error("Fetch error:", error);
//       showAlert("Failed to add tax data", "error");
//     }
//   }

// const options = {
//   filter: false,
//   pagination: true,
//   selectableRows: "none",
//   download: false,
//   print: false,
//   viewColumns: false,
//   search: false,
//   responsive: "standard",
//   fixedHeader: true,
//   selectableRowsHeader: false,
//   rowsPerPageOptions: [10, 25, 50, 100],
//   tableBodyHeight: "400px"
// };

//   const getMuiTheme = () =>
//     createTheme({
//       components: {
//         MUIDataTableHeadCell: {
//           styleOverrides: {
//             root: {
//               "&:first-of-type": {
//                 display: "none", // Hides the first column's header
//               },
//             },
//           },
//         },
//       },
//     });
//   return (
//     <>
//       <List style={{ background: "none", padding: 5 }}>
//         <StatusAlert
//           open={alertOpen}
//           setOpen={setAlertOpen}
//           message={alertMessage}
//           severity={alertSeverity}
//         />
//         <ListItemText style={{ background: "none", margin: "5px 0" }}>
//           <React.Fragment>
//             <Button
//               variant="contained"
//               onClick={handleClickOpen}
//               sx={{
//                 backgroundColor: "blue",
//                 "&:hover": { backgroundColor: "orange" },
//                 textAlign: "center",
//               }}
//             >
//               Manage Role
//             </Button>
//             <Dialog
//               // fullScreen
//               // maxWidth="100vh"
//               fullWidth
//               maxWidth="sm"
//               open={open}
//               onClose={handleClose}
//               TransitionComponent={Transition}
//               PaperProps={{
//                 style: {
//                   position: "absolute",
//                   background: "#141b2d",
//                   top: "0",
//                   backgroundColor: "white",
//                   maxHeight: "95%",
//                   margin: "auto",
//                   overflowX: "hidden",
//                   zIndex: 1200,
//                 },
//               }}
//             >
//               <AppBar sx={{ position: "relative" }}>
//                 <Toolbar>
//                   <IconButton
//                     edge="start"
//                     color="inherit"
//                     onClick={handleClose}
//                     aria-label="close"
//                   >
//                     <CloseIcon />
//                   </IconButton>
//                   <Typography sx={{ ml: 2, flex: 1 }} component="div">
//                     Manage Role
//                   </Typography>
//                 </Toolbar>
//               </AppBar>
//               <Box
//                 component="form"
//                 sx={{
//                   mt: 3,
//                   p: 2,
//                   bgcolor: "#f5f5f5", // Adjusted background color for better contrast
//                   borderRadius: 1,
//                   boxShadow: 1,
//                 }}
//               >
//                 <Grid
//                   container
//                   spacing={2}
//                   style={{ color: "black", margin: "10px" }}
//                 >
//                   <Grid item xs={10} sm={10}>
//                     <Typography
//                       variant="p"
//                       gutterBottom
//                       style={{ color: "black" }}
//                     >
//                       Role Name
//                     </Typography>
//                     <Grid container spacing={2} alignItems="center">
//                       <Grid item xs={12}>
//                         <TextField
//                           variant="outlined"
//                           fullWidth
//                           placeholder="Enter role name"
//                           inputProps={{
//                             style: {
//                               color: "black",
//                               border: "1px solid black",
//                               borderRadius: "5px",
//                             },
//                           }}
//                           InputLabelProps={{ style: { color: "black" } }}
//                           onChange={(e) => setTax_name(e.target.value)}
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               borderColor: "black",
//                               "&:hover fieldset": {
//                                 borderColor: "black",
//                               },
//                               "&.Mui-focused fieldset": {
//                                 borderColor: "black",
//                               },
//                             },
//                             "& .MuiOutlinedInput-input": {
//                               "&::placeholder": { color: "gray" },
//                             },
//                           }}
//                         />
//                       </Grid>
//                     </Grid>
//                   </Grid>
//                 </Grid>

//                 <Button
//                   variant="contained"
//                   autoFocus
//                   color="inherit"
//                   onClick={SaveDate}
//                   sx={{
//                     backgroundColor: "blue",
//                     "&:hover": { backgroundColor: "orange" },
//                     textAlign: "center",
//                     margin: "25px",
//                   }}
//                 >
//                   Save
//                 </Button>
//               </Box>
//             </Dialog>
//           </React.Fragment>
//         </ListItemText>
//         <Divider />
//         <ListItemText style={{ background: "white", margin: 0, width: "100%" }}>
//           <ThemeProvider theme={getMuiTheme()}>
//             <MUIDataTable
//               fullScreen={true}
//               title={"Roles & Permissions"}
//               data={leadSource}
//               columns={columns}
//               options={options}
//             />
//           </ThemeProvider>
//         </ListItemText>
//       </List>
//     </>
//   );
// }

// export default RolesSettings;


import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Stack,
  Collapse,
    Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow,
  MenuItem,
} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import KeyIcon from "@mui/icons-material/Key";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MUIDataTable from "mui-datatables";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import PermissionTable from "./PermissionTable";
import { rolesSettingsApis } from "../../../Data/axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function RolesSettings() {
  const [open, setOpen] = useState(false);
  const [tax_name, setTax_name] = useState("");
  const [leadSource, setLeadSource] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  // Alert state
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Toggle expanded rows for permissions
  const toggleRow = (rowId) => {
    setExpandedRows((prevExpandedRows) => {
      if (prevExpandedRows.includes(rowId)) {
        return prevExpandedRows.filter((id) => id !== rowId);
      } else {
        return [...prevExpandedRows, rowId];
      }
    });
  };

  // Get role data on component mount
  useEffect(() => {
    getData();
  }, []);

  // Fetch roles data using the API
  async function getData() {
    try {
      setIsLoading(true);
      const response = await rolesSettingsApis.getAll();
      
      // If data is available in the response
      if (response && response.data) {
        // Format the data for display
        const formattedData = response.data.map(role => ({
          id: role.id,
          role: role.role,
          status: role.status,
          memberCount: role.role.toLowerCase() === 'admin' ? '1 Member' : 
                      role.role.toLowerCase() === 'hr' ? '11 Member' : '0 Member',
          // Store the full role object for permissions table
          roleData: role
        }));
        
        setLeadSource(formattedData);
      } else {
        setLeadSource([]);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      showAlert("Failed to load roles data", "error");
      setLeadSource([]);
    } finally {
      setIsLoading(false);
    }
  }

  // Delete a role
  async function handleDelete(id) {
    try {
      const response = await rolesSettingsApis.deleteById(id);
      
      if (response) {
        getData();
        showAlert("Role deleted successfully!", "warning");
      }
    } catch (error) {
      console.error("Error deleting role:", error);
      showAlert("Failed to delete role", "error");
    }
  }

  // Toggle role status
  async function handleStatus(id) {
    try {
      const response = await rolesSettingsApis.changeStatus(id);
      
      if (response) {
        getData();
        showAlert("Status changed successfully!", "success");
      }
    } catch (error) {
      console.error("Error changing role status:", error);
      showAlert("Failed to change role status", "error");
    }
  }

  // Save new role
  async function SaveDate() {
    if (!tax_name.trim()) {
      showAlert("Role name cannot be empty", "error");
      return;
    }

    try {
      const username = localStorage.getItem("name") || "admin";
      const response = await rolesSettingsApis.add({
        role: tax_name,
        creator_id: username
      });
      
      if (response) {
        showAlert("Role added successfully!", "success");
        getData();
        setOpen(false);
        setTax_name("");
      }
    } catch (error) {
      console.error("Error adding role:", error);
      showAlert("Failed to add role", "error");
    }
  }

  // Table columns configuration
  const columns = [
    {
      name: "role",
      label: "",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowData = leadSource[tableMeta.rowIndex];
          
          return (
            <div style={{ padding: '12px 0' }}>
              <Typography 
                variant="subtitle1" 
                sx={{ 
                  fontWeight: 'bold',
                  fontSize: '16px',
                  color: 'black'
                }}
              >
                {value}
              </Typography>
              <Typography 
                variant="caption" 
                sx={{ 
                  fontSize: '13px', 
                  color: '#777',
                  display: 'block'
                }}
              >
                {rowData.memberCount}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "",
      options: {
        customHeadRender: () => null,
        customBodyRender: (value, tableMeta) => {
          const rowId = tableMeta.rowIndex;
          const isExpanded = expandedRows.includes(rowId);
          const roleName = leadSource[rowId]?.role?.toLowerCase();
          const isAdmin = roleName === 'admin' || roleName === 'administrator';
          
          return (
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'flex-end'
            }}>
              {isAdmin ? (
                <Typography sx={{ 
                  color: 'grey.600',
                  fontSize: '14px',
                  padding: '12px 8px'
                }}>
                  Admin permissions can not be changed
                </Typography>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    onClick={() => toggleRow(rowId)}
                    startIcon={<KeyIcon />}
                    sx={{
                      color: isExpanded ? 'primary.main' : '#555',
                      borderColor: isExpanded ? 'primary.main' : '#bbb',
                      '&:hover': {
                        borderColor: 'primary.main',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      },
                      height: '36px',
                      textTransform: 'none',
                      fontWeight: 'medium',
                      fontSize: '14px'
                    }}
                  >
                    Permissions
                  </Button>
                  
                  <Collapse in={isExpanded} timeout="auto" unmountOnExit sx={{ width: '100%', marginTop: 2 }}>
                    <Box sx={{ 
                      padding: 2, 
                      backgroundColor: "#f5f5f5", 
                      borderRadius: 1,
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                      <PermissionTable role={leadSource[rowId]?.roleData} />
                    </Box>
                  </Collapse>
                </>
              )}
            </Box>
          );
        }
      }
    }
  ];

  // MUI DataTable options
  const options = {
    filter: false,
    pagination: true,
    selectableRows: "none",
    download: false,
    print: false,
    viewColumns: false,
    search: false,
    responsive: "standard",
    fixedHeader: true,
    selectableRowsHeader: false,
    rowsPerPageOptions: [5, 10, 25, 50],
    rowsPerPage: 5,
    elevation: 0,
    rowHover: false,
    customFooter: () => null,
    textLabels: {
      body: {
        noMatch: isLoading ? "Loading..." : "No roles found",
        toolTip: "Sort",
      }
    }
  };

  // Custom theme for the MUI DataTable
  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTableHeadCell: {
          styleOverrides: {
            root: {
              "&:first-of-type": {
                display: "none", 
              },
            },
          },
        },
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              padding: "8px 16px",
              borderBottom: '1px solid #eaeaea'
            },
          },
        },
        MUIDataTableToolbar: {
          styleOverrides: {
            root: {
              backgroundColor: "white",
              paddingLeft: '24px'
            },
            titleText: {
              color: "black",
              fontWeight: "bold",
              fontSize: '20px'
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
              borderRadius: "8px",
              overflow: 'hidden',
              border: '1px solid #eaeaea'
            },
          },
        },
        MuiTableRow: {
          styleOverrides: {
            root: {
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.01) !important"
              }
            }
          }
        },
        MUIDataTablePagination: {
          styleOverrides: {
            root: {
              borderTop: '1px solid #eaeaea',
              color: 'black'
            }
          }
        }
      },
    });

  return (
    <Box p={3}>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      
      <Box mb={3} display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          onClick={handleClickOpen}
          sx={{
            backgroundColor: "primary.main",
            "&:hover": { backgroundColor: "primary.dark" },
          }}
        >
          Add New Role
        </Button>
      </Box>
      
      <ThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title="Roles & Permissions"
          data={leadSource}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
      
      {/* Add new role dialog */}
      {/* <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
          },
        }}
      >
        <AppBar sx={{ position: "relative", backgroundColor: "primary.main" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              Add New Role
            </Typography>
          </Toolbar>
        </AppBar>
        <Box
          component="form"
          sx={{
            mt: 3,
            p: 3,
            bgcolor: "#f5f5f5",
            borderRadius: 1,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom sx={{ color: "black", fontWeight: "medium" }}>
                Role Name
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="Enter role name"
                value={tax_name}
                onChange={(e) => setTax_name(e.target.value)}
                sx={{
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "black",
                    "&:hover fieldset": {
                      borderColor: "black",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "primary.main",
                    },
                  },
                }}
              />
            </Grid>
          </Grid>

          <Box mt={3} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              onClick={SaveDate}
              sx={{
                backgroundColor: "primary.main",
                "&:hover": { backgroundColor: "primary.dark" },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Dialog> */}
      <Dialog
  fullWidth
  maxWidth="md"
  open={open}
  onClose={handleClose}
  TransitionComponent={Transition}
  PaperProps={{
    style: {
      backgroundColor: "white",
      maxHeight: "95%",
      margin: "auto",
      overflowX: "hidden",
    },
  }}
>
  <Box sx={{ borderBottom: '1px solid #e0e0e0' }}>
    <Typography 
      sx={{ 
        p: 2, 
        fontWeight: 'medium', 
        fontSize: '18px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <span>Manage Role</span>
      <IconButton
        edge="end"
        color="inherit"
        onClick={handleClose}
        aria-label="close"
        sx={{ color: '#999' }}
      >
        <CloseIcon />
      </IconButton>
    </Typography>
  </Box>

  {/* Table of existing roles */}
  <Box sx={{ p: 2, bgcolor: '#f7f9fc' }}>
    <Box sx={{ bgcolor: 'white', mb: 3, border: '1px solid #e0e0e0', borderRadius: 1 }}>
      <Table sx={{ minWidth: 650 }} aria-label="roles table">
        <TableHead sx={{ bgcolor: '#f5f7fa' }}>
          <TableRow>
            <TableCell sx={{ width: '50px', py: 1.5, color: '#666' }}>#</TableCell>
            <TableCell sx={{ py: 1.5, color: '#666' }}>User Role</TableCell>
            <TableCell sx={{ width: '150px', py: 1.5, color: '#666' }}></TableCell>
            <TableCell align="right" sx={{ py: 1.5, color: '#666' }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
  {/* Admin row */}
  <TableRow>
    <TableCell sx={{ color: "#333" }}>1</TableCell>
    <TableCell sx={{ color: "#333", fontWeight: "medium" }}>App Administrator</TableCell>
    <TableCell>
      <Box sx={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        bgcolor: '#edf2f7', 
        borderRadius: 1,
        px: 1,
        py: 0.5
      }}>
        <Box sx={{ 
          bgcolor: '#3182ce', 
          color: 'white', 
          width: 18, 
          height: 18, 
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '11px',
          fontWeight: 'bold',
          mr: 1
        }}>
          0
        </Box>
        <Typography variant="caption" sx={{ color: '#718096' }}>
          Unsynced Users
        </Typography>
      </Box>
    </TableCell>
    <TableCell align="right" sx={{ color: "#666" }}>Default role can not be deleted.</TableCell>
  </TableRow>
  
  {/* Employee row */}
  <TableRow>
    <TableCell sx={{ color: "#333" }}>2</TableCell>
    <TableCell sx={{ color: "#333", fontWeight: "medium" }}>Employee</TableCell>
    <TableCell>
      {/* Unsynced users box - already has proper styling */}
      <Box sx={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        bgcolor: '#edf2f7', 
        borderRadius: 1,
        px: 1,
        py: 0.5
      }}>
        <Box sx={{ 
          bgcolor: '#3182ce', 
          color: 'white', 
          width: 18, 
          height: 18, 
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '11px',
          fontWeight: 'bold',
          mr: 1
        }}>
          0
        </Box>
        <Typography variant="caption" sx={{ color: '#718096' }}>
          Unsynced Users
        </Typography>
      </Box>
    </TableCell>
    <TableCell align="right">
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          sx={{ 
            borderColor: '#3182ce', 
            color: '#3182ce', 
            mr: 1,
            textTransform: 'none',
            '&:hover': { backgroundColor: '#ebf8ff' }
          }} 
          variant="outlined" 
          startIcon={<RefreshIcon />}
        >
          Reset Permissions
        </Button>
      </Box>
    </TableCell>
  </TableRow>
  
  {/* Client row */}
  <TableRow>
    <TableCell sx={{ color: "#333" }}>3</TableCell>
    <TableCell sx={{ color: "#333", fontWeight: "medium" }}>Client</TableCell>
    <TableCell>
      {/* Unsynced users box */}
      <Box sx={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        bgcolor: '#edf2f7', 
        borderRadius: 1,
        px: 1,
        py: 0.5
      }}>
        <Box sx={{ 
          bgcolor: '#3182ce', 
          color: 'white', 
          width: 18, 
          height: 18, 
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '11px',
          fontWeight: 'bold',
          mr: 1
        }}>
          0
        </Box>
        <Typography variant="caption" sx={{ color: '#718096' }}>
          Unsynced Users
        </Typography>
      </Box>
    </TableCell>
    <TableCell align="right">
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          sx={{ 
            borderColor: '#3182ce', 
            color: '#3182ce', 
            mr: 1,
            textTransform: 'none',
            '&:hover': { backgroundColor: '#ebf8ff' }
          }} 
          variant="outlined" 
          startIcon={<RefreshIcon />}
        >
          Reset Permissions
        </Button>
      </Box>
    </TableCell>
  </TableRow>
  
  {/* Manager row */}
  <TableRow>
    <TableCell sx={{ color: "#333" }}>4</TableCell>
    <TableCell sx={{ color: "#333", fontWeight: "medium" }}>Manager</TableCell>
    <TableCell>
      {/* Unsynced users box */}
      <Box sx={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        bgcolor: '#edf2f7', 
        borderRadius: 1,
        px: 1,
        py: 0.5
      }}>
        <Box sx={{ 
          bgcolor: '#3182ce', 
          color: 'white', 
          width: 18, 
          height: 18, 
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '11px',
          fontWeight: 'bold',
          mr: 1
        }}>
          0
        </Box>
        <Typography variant="caption" sx={{ color: '#718096' }}>
          Unsynced Users
        </Typography>
      </Box>
    </TableCell>
    <TableCell align="right">
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          sx={{ 
            borderColor: '#e53e3e', 
            color: '#e53e3e',
            textTransform: 'none',
            '&:hover': { backgroundColor: '#fff5f5' }
          }} 
          variant="outlined" 
          startIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      </Box>
    </TableCell>
  </TableRow>
</TableBody>
      </Table>
    </Box>

    {/* Add new role form */}
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Box sx={{ mb: 0.5 }}>
          <Typography variant="body2" fontWeight="medium" component="label" htmlFor="role-name">
            Role Name <Box component="span" sx={{ color: 'error.main' }}>*</Box>
          </Typography>
        </Box>
        <TextField
          id="role-name"
          variant="outlined"
          fullWidth
          placeholder="e.g. HR"
          size="small"
          value={tax_name}
          onChange={(e) => setTax_name(e.target.value)}
          sx={{
            backgroundColor: "white",
            "& .MuiOutlinedInput-root": {
              borderColor: "#e2e8f0",
            },
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={{ mb: 0.5 }}>
          <Typography variant="body2" fontWeight="medium">
            Import from Role
          </Typography>
        </Box>
        <TextField
          select
          fullWidth
          size="small"
          value="--"
          sx={{
            backgroundColor: "white",
          }}
        >
          <MenuItem value="--">--</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  </Box>

  {/* Dialog actions */}
  <Box sx={{ 
    display: 'flex', 
    justifyContent: 'flex-end', 
    p: 2, 
    borderTop: '1px solid #e0e0e0'
  }}>
    <Button 
      onClick={handleClose} 
      sx={{ 
        mr: 1, 
        color: '#4a5568',
        '&:hover': { backgroundColor: '#f7fafc' }
      }}
    >
      Close
    </Button>
    <Button 
      variant="contained" 
      onClick={SaveDate}
      sx={{
        backgroundColor: '#4299e1',
        '&:hover': { backgroundColor: '#3182ce' }
      }}
      startIcon={<SaveIcon />}
    >
      Save
    </Button>
  </Box>
</Dialog>
    </Box>
  );
}

export default RolesSettings;